<template lang="pug">
.AuthSocialButtons.auth-social-buttons
  .auth-social-buttons__row
    button.auth-social-buttons__button.is--facebook(
      @click.prevent="onSocialClick('facebook')"
      :loading="socialLoading === 'facebook'",
    )
      BrandsFacebookFIcon.auth-social-buttons__button-icon.svg-icon.facebook-icon
    button.auth-social-buttons__button.is--linkedin(
      @click.prevent="onSocialClick('linkedin')",
      :loading="socialLoading === 'linkedin'",
    )
      BrandsLinkedinInIcon.auth-social-buttons__button-icon.svg-icon.linkedin-icon
    button.auth-social-buttons__button.is--google(
      @click.prevent="onSocialClick('google-oauth2')",
      :loading="socialLoading === 'google-oauth2'",
    )
      GoogleIcon.auth-social-buttons__button-icon.svg-icon.google-icon
  BaseNotificationInline.auth-social-buttons__notification-inline(
    :value="loginError"
  )
</template>

<script>
import Auth from 'Auth';
import BaseAuthModel from 'Models/BaseAuthModel';
import BaseNotificationInline from 'Components/Base/BaseNotificationInline';
import BrowserBackButtonMixin from 'Mixins/browserBackButtonMixin';
import BrandsFacebookFIcon from 'images/svg-icons/brands-facebook-f.svg';
import BrandsLinkedinInIcon from 'images/svg-icons/brands-linkedin-in.svg';
import GoogleIcon from 'images/svg-icons/google-social-icon.svg';

const socialNameMap = {
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  'google-oauth2': 'Google',
};

export default {
  name: 'AuthSocialButtons',
  components: {
    BaseNotificationInline,
    BrandsFacebookFIcon,
    BrandsLinkedinInIcon,
    GoogleIcon,
  },
  mixins: [BrowserBackButtonMixin],
  props: {
    signup: Boolean,
    resetError: true, // eslint-disable-line  vue/require-prop-type-constructor
    keepLoadingOnSuccess: Boolean,
  },
  data() {
    return {
      socialLoading: '',
      loginError: '',
    };
  },
  computed: {
    action() {
      return this.signup ? 'Signup' : 'Login';
    },
  },
  watch: {
    resetError() {
      this.loginError = '';
    },

  },
  async mounted() {
    const isErrorOnReload = Auth.isErrorOnReload();
    if (isErrorOnReload) {
      const error = await Auth.parseErrorOnReload();
      if (error) this.onLoginError(error);
    }
  },
  methods: {
    getSocialName() {
      return socialNameMap[this.socialLoading] || 'social';
    },
    $_browserBackButton_fallback() {
      this.socialLoading = '';
    },
    async onSocialClick(social) {
      this.$emit('click');
      this.loginError = '';
      this.socialLoading = social;
      try {
        this.$_browserBackButton_setFallback();
        const authResult = await Auth.socialLogin(social);
        this.$_browserBackButton_removeFallback();
        this.onSuccess(authResult);
        if (!this.keepLoadingOnSuccess) this.socialLoading = false;
      } catch (e) {
        this.$_browserBackButton_removeFallback();
        this.onLoginError(e);
        this.socialLoading = false;
      }
    },
    async onLoginError(error) {
      if (error.original === 'User closed the popup window') return;
      if ((error.description || error.errorDescription) === 'user is blocked') {
        this.loginError = BaseAuthModel.getErrorMessageByServerError({ code: 'blocked_user' });
        return;
      }
      this.loginError = error.description
        || error.errorDescription
        || BaseAuthModel.getErrorMessageByServerError(error);
      if (this.loginError === 'social_mfa_required') {
        this.loginError = `
          Since you have enabled two factor authentication, as an additional security step,
          please log in with ${this.getSocialName()} once again. Thank you!
        `;
      }
    },
    onSuccess(loginData) {
      this.$emit('success', loginData);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.auth-social-buttons
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: center
  width: 100%
  max-width: 185px
  &__row
    display: flex
    flex-direction: row
    justify-content: space-between
    width: 100%
  @media screen and (max-width: 576px)
    max-width: 195px
  &__notification-inline
    margin-top: 15px
    margin-bottom: 0
  &__button
    width: 48px
    height: 48px
    display: flex
    align-items: center
    justify-content: center
    background-color: $white
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%)
    &:hover
      +mt(.3s)
      transform: scale3d(1.05, 1.05, 1.05)
    &.is--facebook
      fill: #3B5998
      .auth-social-buttons__button-icon
        width: 13px
      &:hover
        +mt(.3s)
        background: #3B5998 !important
        fill: $white
    &.is--linkedin
      fill: #0077B5
      .auth-social-buttons__button-icon
        width: 21px
      &:hover
        +mt(.3s)
        background: #0077B5 !important
        fill: $white
    &.is--google
      .auth-social-buttons__button-icon
        width: 21px
        height: 21px
        path
          +mt(.3s)
      &:hover
        +mt(.3s)
        background: #4285F4 !important
        .auth-social-buttons__button-icon
          path
            +mt(.3s)
            fill: $white
  &__button-icon
    height: 24px
</style>
